module.exports = __webpack_public_path__ + "fonts/1120eb10-bbb9-40ce-8295-69fe28a06b68.48725fc4.woff2";